import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { LocalizableComponent } from '../../../../localization/localizable.component';

export interface EmailQuoteDialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'broker-email-quote-dialog',
  templateUrl: './email-quote-dialog.component.html',
  styleUrls: ['./email-quote-dialog.component.scss']
})
export class EmailQuoteDialogComponent extends LocalizableComponent {
  @Output() submitEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  isSent = false;
  title: string;
  text: string;

  constructor(
    @Inject(L10N_LOCALE) locale: L10nLocale,
    @Inject(MAT_DIALOG_DATA) public data: EmailQuoteDialogData,
    private dialogRef: MatDialogRef<EmailQuoteDialogComponent>
  ) {
    super(locale);
    this.title = data?.title || '';
    this.text = data?.text || '';
  }

  handleSubmit(): void {
    if (!this.isSent) {
      this.submitEvent.emit();
    }
  }

  markAsSent(): void {
    this.isSent = true;
    setTimeout(() => this.dialogRef.close(true), 1000);
  }
}
